import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CopyIcon, ArrowForwardIcon } from '@rsos/assets/icons';
import { Box, Text, Button } from '@rsos/base-components';
import { ButtonText } from '@rsos/components/capstone/Location/styles/common.styles';
import { selectExistingRequest } from '@rsos/reduxDataStore';
import copyToClipboard from '@rsos/utils/copyToClipboard';
import {
  trackOpenTransportLink,
  trackCopyTrackingLink,
} from '../../../gainsightTrackings/airAmbulanceTrackings';

const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.primaryBase};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const AircraftDetails = ({ brandTail }) => (
  <Box mt={2} mb={2}>
    <Text color="secondaryText" size="normal">
      Aircraft Name - Tail Number
    </Text>
    <Text color="primaryText" size="normal">
      {brandTail}
    </Text>
  </Box>
);

const TrackingUrlDisplay = ({ trackingUrl }) => (
  <Box mt={2} mb={2}>
    <Text color="secondaryText" size="normal">
      Tracking URL
    </Text>
    <Text size="normal">
      <StyledLink href={trackingUrl} target="_blank" rel="noopener noreferrer">
        {trackingUrl}
      </StyledLink>
    </Text>
  </Box>
);

const TrackingActions = ({ onCopyLink, onTrackAirAmbulance }) => (
  <Box horizontal justify="space-between" mt={2} mb={2}>
    <Button type="button" grow btnType="tertiary" onClick={onCopyLink}>
      <CopyIcon /> <ButtonText>Copy Link</ButtonText>
    </Button>
    <Button grow btnType="tertiary" type="button" onClick={onTrackAirAmbulance}>
      <ArrowForwardIcon /> <ButtonText>Track Air Ambulance</ButtonText>
    </Button>
  </Box>
);

const AirAmbulanceStatusTracking = () => {
  const existingRequest = useSelector(selectExistingRequest);
  const { brand_tail: brandTail, tracking_url: trackingUrl } =
    existingRequest?.body || {};

  const handleCopyLink = () => {
    copyToClipboard(trackingUrl);
    trackCopyTrackingLink({
      airAmbulanceUrl: trackingUrl,
      requestId:
        existingRequest?.body?.ext_trip_id || existingRequest?.request_id,
    });
  };

  const handleTrackAirAmbulance = () => {
    window.open(trackingUrl, '_blank', 'noopener,noreferrer');
    trackOpenTransportLink({
      airAmbulanceUrl: trackingUrl,
      requestId:
        existingRequest?.body?.ext_trip_id || existingRequest?.request_id,
    });
  };

  // Only render if we have actual tracking data to display
  const hasTrackingData = brandTail || trackingUrl;

  if (!hasTrackingData) {
    return null;
  }

  return (
    <>
      <Box m={1}>
        {brandTail && <AircraftDetails brandTail={brandTail} />}
        {trackingUrl && <TrackingUrlDisplay trackingUrl={trackingUrl} />}
      </Box>
      {trackingUrl && (
        <TrackingActions
          trackingUrl={trackingUrl}
          onCopyLink={handleCopyLink}
          onTrackAirAmbulance={handleTrackAirAmbulance}
        />
      )}
    </>
  );
};

export default AirAmbulanceStatusTracking;
